/*
  Back in stock sign-up for every product page (owner, 16 Oct 2026: "all sold out items need notify when available").
  When the chosen option is sold out, a "Notify Me When Available" button appears under the add to cart button.
  It opens a small form that signs the email up to Klaviyo's back in stock list for each sold-out variant;
  Klaviyo's live "Back In Stock Flow" sends the email when stock returns.

  Works with the kinds of product page on the theme:
  - pdp-k (pk-picker): every sold-out piece in the current selection (seat, back, chaise; or duo items)
  - FurAway (pk-fa-sets): the selected card in the selected colour and size
  - pdp-s (ps-buy): the selected variant
  - older templates (form posting to /cart/add): the variant in the form's "id" field
  Loaded from snippets/pdp-bis.liquid, which sets window.NolanBIS = { company, product }.
*/
(function () {
  var CFG = window.NolanBIS || {};
  if (!CFG.company) { console.error('[pdp-bis] Klaviyo company id missing; back in stock sign-up is off'); return; }

  var ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(CFG.company);
  var LABEL = 'Notify Me When Available';

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function subscribe(email, variantId) {
    return fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': '2024-10-15' },
      body: JSON.stringify({ data: {
        type: 'back-in-stock-subscription',
        attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email: email } } } },
        relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } } }
      } })
    }).then(function (r) {
      if (r.ok) return;
      return r.text().then(function (t) {
        var msg = 'HTTP ' + r.status;
        try { var j = JSON.parse(t); if (j.errors && j.errors[0]) msg = j.errors[0].detail || j.errors[0].title || msg; } catch (e) { /* body was not JSON; keep the status */ }
        throw new Error(msg);
      });
    });
  }

  /* ---------------------------------------------------------------- form */
  var modal, current = [];
  function buildModal() {
    modal = document.createElement('div');
    modal.className = 'nbis';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="nbis__backdrop" data-nbis-close></div>' +
      '<div class="nbis__panel" role="dialog" aria-modal="true" aria-labelledby="nbis-title">' +
        '<button type="button" class="nbis__x" data-nbis-close aria-label="Close"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
        '<p class="nbis__title" id="nbis-title">Get an email when it\'s back</p>' +
        '<p class="nbis__product" data-nbis-product></p>' +
        '<ul class="nbis__items" data-nbis-items></ul>' +
        '<form class="nbis__form" data-nbis-form novalidate>' +
          '<label class="nbis__label" for="nbis-email">Email</label>' +
          '<input class="nbis__input" id="nbis-email" type="email" name="email" autocomplete="email" required placeholder="you@example.com">' +
          '<p class="nbis__error" data-nbis-error hidden></p>' +
          '<button type="submit" class="nbis__submit" data-nbis-submit>Notify Me</button>' +
          '<p class="nbis__fine">We\'ll email you once when it\'s back in stock.</p>' +
        '</form>' +
        '<div class="nbis__done" data-nbis-done hidden>' +
          '<p class="nbis__title">You\'re on the list</p>' +
          '<p>We\'ll email you as soon as it\'s back in stock.</p>' +
          '<button type="button" class="nbis__submit" data-nbis-close>Done</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function (e) { if (e.target.closest('[data-nbis-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
    modal.querySelector('[data-nbis-form]').addEventListener('submit', function (e) {
      e.preventDefault();
      var input = modal.querySelector('#nbis-email');
      var email = input.value.trim();
      var err = modal.querySelector('[data-nbis-error]');
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { err.textContent = 'Please enter a valid email address.'; err.hidden = false; input.focus(); return; }
      err.hidden = true;
      var btn = modal.querySelector('[data-nbis-submit]');
      btn.disabled = true;
      btn.textContent = 'Sending…';
      Promise.all(current.map(function (it) { return subscribe(email, it.id); })).then(function () {
        modal.querySelector('[data-nbis-form]').hidden = true;
        modal.querySelector('[data-nbis-done]').hidden = false;
        document.dispatchEvent(new CustomEvent('nolan:bis-subscribed', { detail: { variants: current.map(function (it) { return it.id; }) } }));
      }).catch(function (error) {
        console.error('[pdp-bis] back in stock sign-up failed', error);
        err.textContent = 'We couldn\'t sign you up (' + error.message + '). Please try again.';
        err.hidden = false;
      }).finally(function () {
        btn.disabled = false;
        btn.textContent = 'Notify Me';
      });
    });
  }
  var lastFocus = null;
  function open(items) {
    if (!items.length) return;
    if (!modal) buildModal();
    current = items;
    lastFocus = document.activeElement;
    modal.querySelector('[data-nbis-product]').textContent = CFG.product || '';
    var named = items.filter(function (it) { return it.label; });
    modal.querySelector('[data-nbis-items]').innerHTML = named.map(function (it) { return '<li>' + esc(it.label) + '</li>'; }).join('');
    modal.querySelector('[data-nbis-items]').hidden = !named.length;
    modal.querySelector('[data-nbis-form]').hidden = false;
    modal.querySelector('[data-nbis-done]').hidden = true;
    modal.querySelector('[data-nbis-error]').hidden = true;
    modal.hidden = false;
    document.documentElement.classList.add('nbis-open');
    setTimeout(function () { modal.querySelector('#nbis-email').focus(); }, 30);
  }
  function close() {
    modal.hidden = true;
    document.documentElement.classList.remove('nbis-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------------------------------------------------------------- button per buy box */
  function attach(anchor, getSoldOut, watch) {
    if (!anchor || anchor.__nbis) return;
    anchor.__nbis = true;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'nbis-btn';
    btn.textContent = LABEL;
    btn.hidden = true;
    anchor.insertAdjacentElement('afterend', btn);
    var update = function () {
      var items;
      try { items = getSoldOut() || []; } catch (err) { console.error('[pdp-bis] could not read the selected variant', err); items = []; }
      btn.hidden = !items.length;
      btn._items = items;
    };
    btn.addEventListener('click', function () { open(btn._items || []); });
    (watch || []).forEach(function (el) {
      if (el) new MutationObserver(update).observe(el, { attributes: true, childList: true, characterData: true, subtree: true });
    });
    update();
    return update;
  }

  var SIZE_WORDS = { S: 'Small', M: 'Medium', L: 'Large' };
  function sizeName(sz) { sz = String(sz || '').replace(/\s*\(.*\)\s*$/, ''); return SIZE_WORDS[sz] || sz; }
  function cap(s) { s = String(s || ''); return s.charAt(0).toUpperCase() + s.slice(1); }
  var COVER_PIECES = { seat: 1, back: 1, chaise: 1 };

  function initPk(el) {
    var atc = el.querySelector('[data-pk-atc]');
    if (!atc || typeof el.lines !== 'function') return;
    attach(atc, function () {
      return el.lines().filter(function (l) { return !l.incomplete && l.variant && !l.variant.available; }).map(function (l) {
        var bits = [];
        var colour = l.colour || (el.state && el.state.colour);
        if (colour) bits.push(colour);
        if (l.piece && l.piece !== 'item') bits.push(cap(l.piece) + (COVER_PIECES[l.piece] ? ' cover' : ''));
        if (l.size) bits.push(sizeName(l.size));
        return { id: l.variant.id, label: bits.join(' · ') };
      });
    }, [atc]);
  }

  function initPs(el) {
    var atc = el.querySelector('[data-ps-atc]');
    if (!atc || typeof el.variant !== 'function') return;
    var row = atc.closest('.ps-buy__row') || atc;
    attach(row, function () {
      var v = el.variant();
      if (!v || v.available) return [];
      var opts = (v.options || []).filter(function (o) { return o && o !== 'Default Title'; });
      return [{ id: v.id, label: opts.join(' · ') }];
    }, [atc]);
  }

  /* Older templates. The theme's own script keeps a hidden "id" field on the selected variant and redraws the
     add to cart button on every change, so the button is watched and the field read. Availability comes from
     the product JSON. Two shapes: the kv bundle buy boxes (sofa blankets, mats, bedding: [data-kv-add-to-cart])
     and the plain Shopify product form (pillows, swatches, laundry bag). */
  function initLegacyButton(button, idInput, byId) {
    if (!button || !idInput) return;
    var update = attach(button, function () {
      /* Klaviyo's onsite embed adds its own back in stock button to these older buy boxes; don't show two. */
      if (document.getElementById('klaviyo-bis-button-container')) return [];
      var v = byId[idInput.value];
      if (!v || v.available) return [];
      return [{ id: v.id, label: v.title === 'Default Title' ? '' : v.title.replace(/ \/ /g, ' · ') }];
    }, [button]);
    if (update) {
      var later = function () { setTimeout(update, 50); setTimeout(update, 800); };
      document.addEventListener('change', later);
      document.addEventListener('click', later);
    }
  }

  function initLegacy(product) {
    var byId = {};
    product.variants.forEach(function (v) { byId[v.id] = v; });
    var done = [];
    document.querySelectorAll('[data-kv-add-to-cart]').forEach(function (btn) {
      var root = btn.closest('.kv-bundle, [data-kv-door-mat-bundle]') || btn.parentElement;
      var formId = btn.getAttribute('form');
      var form = formId ? document.getElementById(formId) : btn.closest('form');
      var idInput = root.querySelector('input[name="id"]') || (form && form.querySelector('[name="id"]'));
      initLegacyButton(btn, idInput, byId);
      if (form) done.push(form);
    });
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      if (done.indexOf(form) !== -1) return;
      if (form.closest('#ajaxCart, .cart-drawer, [data-cart-drawer], .ajaxcart, [class*="upsell"], [class*="recommend"]')) return;
      var formId = form.getAttribute('id');
      var submit = form.querySelector('[type="submit"], .js-add-to-cart') || (formId && document.querySelector('[form="' + formId + '"][type="submit"], [form="' + formId + '"].js-add-to-cart'));
      if (submit && submit.hasAttribute('data-kv-add-to-cart')) return;
      initLegacyButton(submit, form.querySelector('[name="id"]'), byId);
    });
  }

  /* FurAway set picker (pk-fa-sets, QA 17 Oct H2): the selected card, colour and size. The card can be another
     product (a set), so the label names it. */
  function initFa(el) {
    var atc = el.querySelector('[data-fa-atc]');
    if (!atc || typeof el.soldOut !== 'function') return;
    attach(atc, function () { return el.soldOut(); }, [atc]);
  }

  function init() {
    var pk = document.querySelectorAll('pk-picker'), ps = document.querySelectorAll('ps-buy'), fa = document.querySelectorAll('pk-fa-sets');
    if (pk.length || ps.length || fa.length) {
      customElements.whenDefined('pk-picker').then(function () { document.querySelectorAll('pk-picker').forEach(initPk); });
      customElements.whenDefined('ps-buy').then(function () { document.querySelectorAll('ps-buy').forEach(initPs); });
      customElements.whenDefined('pk-fa-sets').then(function () { document.querySelectorAll('pk-fa-sets').forEach(initFa); });
      return;
    }
    if (!CFG.soldOut || !CFG.handle || !document.querySelector('[data-kv-add-to-cart], form[action*="/cart/add"]')) return;
    fetch('/products/' + encodeURIComponent(CFG.handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(initLegacy)
      .catch(function (err) { console.error('[pdp-bis] product data unavailable; back in stock button not added', err); });
  }

  window.NolanBIS.open = open;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
